import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-models-s",
  "use": "icon-models-s-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-models-s\">\n<path d=\"M3 8.33301L14 15.6663V26.6663L3 19.333V8.33301Z\" fill=\"#8394EE\" />\n<path d=\"M3 8.33333L14 15.6667L25 8.33333L14 1L3 8.33333Z\" fill=\"#B3BFFF\" />\n<path d=\"M25 8.33301L14 15.6663V26.6663L25 19.333V8.33301Z\" fill=\"#2F54EB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol